import React, { useState } from 'react';
import { useRouter } from 'next/router';
import { useQuery, useMutation } from 'react-query';
import { getAccessToken } from 'utils/authentication';
import { GetCustomerPortal } from 'services/payments';
import { getErrorText } from 'utils/geterrortext';
import { consultations } from 'services/consultation';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';

import UseToast from 'hooks/use-toast';

import ActionButton from '@core/components/actionbutton/ActionButton';
import IconButton from '@core/components/iconbutton/IconButton';

import AlirezaImage from '@core/assets/images/AlirezaZarei.png';
import LinkedinIcon from '@core/assets/icons/linkedin.png';

import CareerIcon from 'assets/images/pages/vip-coaching/career.svg';
import ImmigrationIcon from 'assets/images/pages/vip-coaching/immigration.svg';
import InterviewIcon from 'assets/images/pages/vip-coaching/interview.svg';
import JobIcon from 'assets/images/pages/vip-coaching/job.svg';
import ResumeIcon from 'assets/images/pages/vip-coaching/resume.svg';
import MoreIcon from 'assets/images/pages/vip-coaching/more.svg';
import VideoPreview from 'assets/images/pages/vip-coaching/coaching-preview.png';
import { ArrowDown2 } from 'iconsax-react';

import classes from './VipConsultationWrapper.module.scss';

const VipConsultationWrapper = ({ data }) => {
    const { toast, ToastContainer } = UseToast();
    const router = useRouter();
    const actionMessages = [
        {
            subscriptionStatus: 'premium',
            actionMessage: 'Click the button to schedule a time that suits you. for one <strong> 30-minute meeting per month.</strong>',
            buttonText: 'Schedule a Meeting',
        },
        {
            subscriptionStatus: 'trial',
            actionMessage: 'This feature is not available during the trial. Add a payment method now to ensure your subscription activates automatically after the trial ends, giving you access to VIP consultation meetings.',
            buttonText: 'Add a Payment Method',
        },
        {
            subscriptionStatus: 'freemium',
            actionMessage: 'Only subscribers can access VIP consultations. Go Premium to enjoy a<strong> free 30-minute session monthly</strong> from this page.',
            buttonText: 'Go Premium',
        },
    ];

    const [expanded, setExpanded] = useState('');
    const [videoPlaying, setVideoPlaying] = useState(false);

    const handleChange =
        (panel) => (event, newExpanded) => {
            setExpanded(newExpanded ? panel : false);
        };

    const { mutate } = useMutation(consultations.POST, {
        onSuccess: async (response) => {
            const newWindow = window.open(response?.data?.link, '_blank');
            if (newWindow) {
                newWindow.opener = null;  // Security measure to avoid cross-window communication
            } else {
                router.replace(response?.data?.link);  // Fallback if the new tab/window couldn't be opened
            }
        },
        onError: (error) => {
            toast(getErrorText(error), 'Alert');
        }
    });

    const { data: customerPortalData, isFetching: customePortalIsLoadin, refetch: customePortalRefetch } = useQuery(['customer-portal', getAccessToken()], () => GetCustomerPortal(), {
        onSuccess: (data) => {
            const newWindow = window.open(data?.data?.url, '_blank');
            if (newWindow) {
                newWindow.opener = null;  // Security measure to avoid cross-window communication
            } else {
                router.replace(data?.data?.url);  // Fallback if the new tab/window couldn't be opened
            }
        },
        onError: (error) => {
            toast(getErrorText(error), 'Alert');
        },
        enabled: false
    });

    const actionHandler = () => {
        if(data.has_access)
            return mutate();
        else
            return router.push('/plans');

        // switch (data.subscription_status) {
        //     case 'freemium':
        //         return router.push('/plans');
        //     case 'trial':
        //         // return customePortalRefetch();
        //         return mutate();
        //     case 'premium':
        //         return mutate();
        // }
    };

    const handleLinkedinClick = () => {
        const newWindow = window.open('https://www.linkedin.com/in/alireza-zarei/', '_blank');
        if (newWindow) {
            newWindow.opener = null;  // Security measure to avoid cross-window communication
        } else {
            router.replace('https://www.linkedin.com/in/alireza-zarei/');  // Fallback if the new tab/window couldn't be opened
        }
    };

    return (
        <>
            <ToastContainer />

            <div className={`${classes['wrapper']} container p-lg-0`}>
                <div className='row mb-5'>
                    <div className='col-xl-7 col-12 mb-3 mb-xl-0'>
                        <div className={classes.action}>
                            <h3>
                                Personalized Coaching for Your Professional Growth
                            </h3>
                            <p>
                                Get 30-minute expert-led coaching sessions every month with your subscription.
                            </p>
                            <ActionButton
                                onClick={actionHandler}
                                loading={customePortalIsLoadin}
                            >
                                Schedule Your Free Session
                            </ActionButton>
                        </div>
                    </div>
                    <div className='col-xl-5 col-12'>
                        <div className={classes['coach-info']}>
                            <img className={classes['coach-image']} src={AlirezaImage.src} alt='Alireza Zarei' />
                            <h3>
                                Alireza Zarei
                            </h3>
                            <p>
                                Founder of Pharmuni and CEO of Zamann Pharma Support GmbH
                            </p>
                            <IconButton className={classes['linkedin-image']} onClick={handleLinkedinClick} >
                                <img src={LinkedinIcon.src} alt='Linkedin Icon' />
                            </IconButton>

                        </div>
                    </div>
                </div>
                <div className='row mb-5'>
                    <div className='col-12'>
                        <div className={classes.coaching}>
                            <h4>Coaching Topics</h4>
                            <div className="row">
                                <div className="col-xxl-6 col-12">
                                    <div className={classes.item}>
                                        <ResumeIcon />
                                        <div>
                                            <h5>
                                                Resume & Cover Letter Review
                                            </h5>
                                            <p>
                                                Boost your job prospects by expert feedback.
                                            </p>
                                        </div>
                                    </div>
                                    <div className={classes.item}>
                                        <InterviewIcon />
                                        <div>
                                            <h5>
                                                Mock Interviews
                                            </h5>
                                            <p>
                                                Practice interviews to boost your confidence and performance
                                            </p>
                                        </div>
                                    </div>
                                    <div className={classes.item}>
                                        <CareerIcon />
                                        <div>
                                            <h5>
                                                Career Path Guidance
                                            </h5>
                                            <p>
                                                Guiding you toward the right career path.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xxl-6 col-12">
                                    <div className={classes.item}>
                                        <ImmigrationIcon />
                                        <div>
                                            <h5>
                                                Immigration Advice
                                            </h5>
                                            <p>
                                                Expert guidance on immigration pathways and requirements.
                                            </p>
                                        </div>
                                    </div>
                                    <div className={classes.item}>
                                        <JobIcon />
                                        <div>
                                            <h5>
                                                Job Hunting Tips
                                            </h5>
                                            <p>
                                                land your ideal job faster with expert guidance.
                                            </p>
                                        </div>
                                    </div>
                                    <div className={classes.item}>
                                        <MoreIcon />
                                        <div>
                                            <h5>
                                                And More...
                                            </h5>
                                            <p>
                                                And much more to support your success.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={classes['video-section']}>
                    <h3>Your VIP Meeting: A Quick Intro</h3>
                    <p>Get the most out of your VIP Consultation with a quick guide from your mentor.</p>
                    <div className={classes['video-wrapper']}>
                        <div className='d-flex justify-content-center mb-5' onClick={() => setVideoPlaying(true)}>
                            {!videoPlaying ? (
                                <img
                                    src={VideoPreview.src}
                                    alt="Video Thumbnail"
                                    role='button'
                                />
                            ) : (
                                <iframe
                                    width="100%"
                                    maxWidth="100%"
                                    style={{
                                        borderRadius: '20px',
                                        maxWidth: '700px',
                                      }}
                                    height="394px"
                                    borderRadius="10px"
                                    src="https://www.youtube.com/embed/0JKoQKZ5Cig?autoplay=1"
                                    allow=" autoplay; clipboard-write; encrypted-media; gyroscope;"
                                    allowFullScreen
                                ></iframe>
                            )}
                        </div>
                    </div>
                </div>
                <div className={classes['coacher']}>
                    <div className="row">
                        <div className="col-lg-6 col-12 ">
                            <div className='d-flex gap-3 mt-3'>
                                <div className={classes['image-wrapper']}>
                                    <img src={AlirezaImage.src} alt='Alireza Zarei' />
                                </div>
                                <div>
                                    <h3>
                                        Alireza Zarei
                                    </h3>
                                    <p>
                                        Founder of Pharmuni and CEO of Zamann Pharma Support GmbH
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-12">
                            <div className={classes['coacher-details']}>
                                <Accordion
                                    expanded={expanded === 'panel1'}
                                    onChange={handleChange('panel1')}
                                    sx={{ boxShadow: 'none', '&:before': { display: 'none' }, borderBottom: '1px solid #A6A5A3' }}
                                >
                                    <AccordionSummary
                                        expandIcon={<ArrowDown2 />}
                                        aria-controls="panel1d-content"
                                        id="panel1d-header"
                                        sx={{ paddingLeft: 0 }}
                                    >
                                        About Alireza
                                    </AccordionSummary>
                                    <AccordionDetails sx={{ paddingLeft: 0 }}>
                                        <p>
                                            Alireza Zarei brings 20+ years of experience in regulated industries,
                                            focusing on pharmaceutical quality, compliance, and digital innovation.
                                            He has led projects with global leaders like Takeda, BioNTech, and Roche.
                                        </p>
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion
                                    expanded={expanded === 'panel2'}
                                    onChange={handleChange('panel2')}
                                    sx={{ boxShadow: 'none', borderBottom: '1px solid #A6A5A3', borderRadius: '0 !important', '&:before': { display: 'none' } }}
                                >
                                    <AccordionSummary
                                        expandIcon={<ArrowDown2 />}
                                        aria-controls="panel2d-content"
                                        id="panel2d-header"
                                        sx={{ paddingLeft: 0 }}
                                    >
                                        Expertise
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <p>
                                            <ul>
                                                <li>Quality Management and Compliance</li>
                                                <li>Digital Transformation in Pharma</li>
                                                <li>Learning Management Systems</li>
                                                <li>Computer System Validation (CSV)</li>
                                                <li>Laboratory Information Management Systems (LIMS)</li>
                                            </ul>
                                        </p>
                                    </AccordionDetails>
                                </Accordion>
                            </div>

                        </div>
                    </div>
                </div>
                <div className={classes['how-works']}>
                    <h3>
                        How it works
                    </h3>
                    <div className={classes.item}>
                        <h4>
                            <span>1</span> Subscribe
                        </h4>
                        <p>
                            Ensure you’re on our Annual or Monthly premium plan to unlock this exclusive feature.
                        </p>
                    </div>
                    <div className={classes.item}>
                        <h4>
                            <span>2</span> Pick a Time
                        </h4>
                        <p>
                            Choose a 30-minute slot that fits your schedule. Sessions are available monthly and are completely free for premium members.
                        </p>
                    </div>
                    <div className={classes.item}>
                        <h4>
                            <span>3</span> Meet Your Expert
                        </h4>
                        <p>
                            Connect via PC or phone, share your career goals, and receive actionable advice from Alireza.
                        </p>
                    </div>
                </div>
            </div>
        </>
    );
};

export default VipConsultationWrapper;